
<lib-accueil-entreprise [configuration]="configuration" [companyId]="companySiteId" [menuConfig]="menuConfig" *ngIf="menuConfig"></lib-accueil-entreprise>

<!-- INSERT LIBS HERE -->
<p-toast position="top-right" key="SUCCESS_RENIT_PASSWORD"></p-toast>
